import { combineReducers } from "redux";

export default combineReducers({
    selectedItem,
    formKey
})

export function selectedItem(state = {}, action) {
    return action.item || {}
}

export function formKey(state = {}, action) {
    return action.formKey || null
}